import React, { useState } from "react";
import {
  FileOutlined,
  SettingOutlined,
  LayoutOutlined,
  BugOutlined,
} from "@ant-design/icons";
import { Menu, Checkbox } from "antd";
import { exportNetwork } from "./Export.js";
import { nodesExt, edgesExt, anyEvidence } from "./Flow.js";
import { handleFile } from "./Import.js";
import { getNodeNamesOnly, setNodeNamesOnly } from "./UserSettings.js";
import { setRefreshNodes } from "./App.js";

import "../css/header.css";

/*
Top bar of the app. 
*/

//create your forceUpdate hook
export function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update state to force render
}

function Header({ setImport, setNewNet, openCloseSettings, forceUpdateApp }) {
  const forceUpdate = useForceUpdate();

  const items = [
    {
      label: "File",
      key: "FileMenu",
      icon: <FileOutlined />,
      children: [
        {
          type: "group",
          label: "Network",
          children: [
            {
              //New Network
              label: "New Network",
              key: "newNet",
              onClick: () => {
                setNewNet();
              },
            },
          ],
        },
        {
          type: "group",
          label: "Files",
          children: [
            {
              //Import
              label: (
                <input
                  type="file"
                  onChange={(f) => handleFile(f, setImport)}
                  accept=".net"
                />
              ),
              key: "import",
              onClick: () => {},
            },
            {
              //Export
              label: "Export",
              key: "export",
              onClick: () => {
                exportNetwork(nodesExt);
              },
            },
          ],
        },
      ],
    },

    {
      label: "View",
      key: "ViewMenu",
      icon: <LayoutOutlined />,
      children: [
        {
          label: (
            <>
              Node names only
              <Checkbox
                checked={getNodeNamesOnly()}
                style={{ marginLeft: "10px" }}
              />
            </>
          ),
          key: "nodeNames",
          onClick: () => {
            setNodeNamesOnly(!getNodeNamesOnly());
            setRefreshNodes();
            forceUpdateApp();
          },
        },
      ],
    },

    {
      label: "Dev Tools",
      key: "DevToolsMenu",
      icon: <BugOutlined />,
      children: [
        {
          label: "Print Nodes",
          key: "printNodes",
          onClick: () => {
            console.log(nodesExt);
          },
        },
        {
          label: "Print Edges",
          key: "printEdges",
          onClick: () => {
            console.log(edgesExt);
          },
        },
      ],
    },

    {
      label: "Settings",
      key: "SettingsMenu",
      icon: <SettingOutlined />,
      onClick: () => {
        openCloseSettings();
      },
    },
  ];

  return (
    <>
      <Menu selectable={false} mode="horizontal" items={items} />{" "}
      {/*triggerSubMenuAction="click"/> */}
    </>
  );
}

export default Header;
